<!-- Dashboard -->
<div class="menu-item me-lg-1">
  <a class="menu-link py-3" >
    <span class="menu-title" >{{currentComponentName}}</span>
  </a>
</div>


